import React from "react";

const ImageViewer = () => {
  const params = new URLSearchParams(window.location.search);
  const image = params.get("image");
  if (!image) {
    return null;
  }

  return (
    <div className="w-[100vw] h-[100vh]">
      <img
        src={image}
        alt="viewer"
        className="w-[100%] h-[100%] object-contain"
      />
    </div>
  );
};

export default ImageViewer;
